import React, { PureComponent } from 'react';
import LoadingIcon from 'appSrc/v5/components/UI/LoadingIcon';
import style from './styles/style.module.css';


export default class LoadingReplace extends PureComponent {
    render() {
        const inlineStyles = { ...this.props.style };
        if( this.props.style ) {
            inlineStyles.minHeight = this.props.size + 'px';
        }

        const className = `loading-shard loading-replace ${ style.loadingReplace } ${ this.props.className}`.trim();
        return (
            <div className={ className } style={ inlineStyles }>
                <LoadingIcon style={ this.props.iconStyles } />
            </div>
        );
    }
}
LoadingReplace.defaultPropTypes = {
    style: {},
    className: '',
};
